import "core-js/es6/map";
import "core-js/es6/set";
import "isomorphic-fetch";
import "es6-promise-promise";
import "raf/polyfill";
import React from "react";
import ReactDom from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./app";
import "./css/glyphicons.css";
import ReactGA from "react-ga";
ReactGA.initialize("UA-137595089-1");
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDom.render(
  <Router basename={"/store"}>
    <App />
  </Router>,
  document.getElementById("root")
);
